import React from 'react'

import Logo from '@/assets/images/logo.png'
import { Link } from 'react-router-dom'

interface Props {
  headerRight?: React.ReactNode
}

const AppHeader: React.FC<Props> = ({ headerRight }) => {
  return (
    <header>
      <div className="container">
        <div className="data-wrap">
          <div className="logo">
            <Link to="/">
              <img src={Logo} alt="" />
            </Link>
          </div>
          {headerRight}
        </div>
      </div>
    </header>
  )
}

export default AppHeader
